import React, { useContext } from 'react';
import Header from "../components/Header";
import SimpleHeader from "../components/SimpleHeader";
import Footer from "../components/Footer";
import videoDatabase from "../database/videos.json";
import Video from "../components/Video";
import { LanguageContext } from "../languages/LanguageContext";
import PageTitle from "../components/PageTitle";

const Videos = () => {
    const { language, translations } = useContext(LanguageContext);
    return (
        <>
            <PageTitle title='Videos'/>
            <Header />
            <div className='main-container'>
                <SimpleHeader
                    title={"videos"}
                    route={"videos"}
                    url={"videos"}
                />
                <div className='video-container max-w'>
                    <div className='video flex col gap-sm'>
                        <iframe height='100%' src="https://www.youtube.com/embed/1p5JWjKjjk4"
                                title="Eröffnung Erasmus-Haus in Althofen" frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen>

                        </iframe>
                        <p>{translations[language]["video5"]}</p>
                    </div>
                    {videoDatabase.map((video, index) => (
                        <Video
                            key={index}
                            description={translations[language][video.translationKey]}
                            path={video.path}
                        />
                    ))}
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Videos;